import React from 'react';
import { graphql, useStaticQuery, Link as GatsbyLink } from 'gatsby';
import {
    Flex,
    IconButton,
    Box,
    Drawer,
    Button,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    DrawerHeader,
    DrawerBody,
    DrawerFooter,
    Link,
    useDisclosure,
    Text,
    Center
} from '@chakra-ui/react';

import { HamburgerIcon } from '@chakra-ui/icons'

import Weather from './Icons/Weather'
import Map from './Icons/Map'
import Newsfeed from './Icons/Newsfeed';
import Calendar from './Icons/Calendar';
import Facebook from './Icons/Facebook';
import styled from '@emotion/styled';
import FacebookTrec from './Icons/Facebook';
import FacebookGeo from './Icons/FacebookGeo';

const MobileNavItem = styled(Box)`
    color: #0069A6 !important;
    text-align: center;
    margin-bottom: 0.75rem;

    > a:hover {
        color: #F3CB2A;
        text-decoration: none;
    }

    > a.active {
        color: #F3CB2A;
        text-decoration: none;
    }
    
`


function MobileNav({ data }) {

    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = React.useRef()
    const document = data.prismicNavigation.data;
return (
    <>
   <Flex flexDirection="column"
    height="100%"
    justifyContent="space-between">
        <Center mx="auto">
            <HamburgerIcon
                color='blue.500'
                cursor='pointer'
                aria-label='Open menu'
                fontSize={{base: 24, sm: 40, md: 48}}
                ref={btnRef} onClick={onOpen}
                variant='ghost'
        />
        </Center>
        <Text textAlign="center" fontSize={{base: 'xs', md: 'sm'}} color="blue.500">
            Menu
        </Text>
   </Flex>
      {/* <Button ref={btnRef} colorScheme='teal' onClick={onOpen}>
        Open
      </Button> */}
      <Drawer
        isOpen={isOpen}
        placement='top'
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader></DrawerHeader>

          <DrawerBody>
          {/* {document.nav_items.map((item, index) => (
                        <MobileNavItem key={index}>
                            <Link as={GatsbyLink} to={item.nav_link.url} activeClassName="active" variant="mobile-nav-item" partiallyActive={true}>
                                {item.nav_label}
                            </Link>
                        </MobileNavItem>
                    ))} */}
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/discover" activeClassName="active" variant="mobile-nav-item">
                            Discover
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/discover/history" activeClassName="active" variant="mobile-sub-nav-item" >
                            Teton Valley History
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/discover/victor" activeClassName="active" variant="mobile-sub-nav-item" >
                            Victor
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/discover/driggs" activeClassName="active" variant="mobile-sub-nav-item" >
                            Driggs
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/discover/tetonia" activeClassName="active" variant="mobile-sub-nav-item" >
                            Tetonia
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem>
                        <Link as={GatsbyLink} to="/discover/maps-travel-info" activeClassName="active" variant="mobile-sub-nav-item" >
                            Maps &amp; Travel Info
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem>
                        <Link as={GatsbyLink} to="/stay" activeClassName="active" variant="mobile-nav-item" >
                            Stay
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem>
                        <Link as={GatsbyLink} to="/play" activeClassName="active" variant="mobile-nav-item" >
                            Play
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem>
                        <Link as={GatsbyLink} to="/eat" activeClassName="active" variant="mobile-nav-item" >
                            Eat
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem>
                        <Link as={GatsbyLink} to="/live" activeClassName="active" variant="mobile-nav-item" >
                            Live
                        </Link>
                    </MobileNavItem>
                    <hr style={{marginBottom: '1rem'}}/>
                    {/* <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/chamber-of-commerce" activeClassName="active" variant="mobile-nav-item" >
                            Chamber
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/chamber-of-commerce/events" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Chamber Events
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/chamber-of-commerce/job-employee-resources" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Job Resources
                        </Link>
                    </MobileNavItem> */}
                    {/* <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/chamber-of-commerce/join" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Join The Chamber
                        </Link>
                    </MobileNavItem> */}
                    {/* <MobileNavItem>
                        <Link as={GatsbyLink} to="/chamber-of-commerce/current-members" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Current Members
                        </Link>
                    </MobileNavItem> */}
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/trec" activeClassName="active" variant="mobile-nav-item" >
                            TREC
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/trec/trec-staff-board" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Staff &amp; Board
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/trec/business-resources" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Business Resources
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/trec/business-involvement" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Business Involvement
                        </Link>
                    </MobileNavItem>
                    {/* <MobileNavItem>
                        <Link as={GatsbyLink} to="/trec/itc-grant" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            ITC Grant
                        </Link>
                    </MobileNavItem> */}
                    {/* <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/teton-geo-center" activeClassName="active" variant="mobile-nav-item">
                            Teton Geo Center
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/teton-geo-center/geo-board" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Geo Board
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/teton-geo-center/idea-gallery-artwork" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Idea Gallery Artwork
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/teton-geo-center/donate" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Support The Geo Center
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem style={{marginBottom: 0}}>
                        <Link as={GatsbyLink} to="/teton-geo-center/volunteer" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Volunteer
                        </Link>
                    </MobileNavItem>
                    <MobileNavItem>
                        <Link as={GatsbyLink} to="/discover/maps-travel-info" activeClassName="active" variant="mobile-sub-nav-item" partiallyActive={true}>
                            Maps &amp; Travel Info
                        </Link>
                    </MobileNavItem> */}
          </DrawerBody>

        </DrawerContent>
      </Drawer>
    </>
  )
}

export default function IconBar() {
    const data = useStaticQuery(graphql`
    {
        prismicNavigation {
          data {
            nav_items {
              nav_label
              nav_link {
                url
              }
            }
          }
        }
      }
  `)

  
    return (
        <Flex w={{base: '100%', md: '100%', lg: '100%'}}
            justifyContent={{base: 'space-between', md: 'space-between'}}
            >
            <Box w={{base: '20%', md: '25%'}} p={{base: 0, md: 4}}>
                <Map />
            </Box>
            {/* <Box w={{base: '20%', md: '25%'}}>
                <Weather />
            </Box> */}
            <Box w={{base: '20%', md: '25%'}} p={{base: 0, md: 4}}>
                <Newsfeed />
            </Box>
            {/* <Box w={{base: '20%', md: '25%'}}>
                <Calendar />
            </Box> */}
            <Box w={{base: '20%', md: '25%'}} p={{base: 0, md: 4}}>
                <FacebookTrec />
            </Box>
            {/* <Box w={{base: '20%', md: '25%'}}>
                <FacebookGeo />
            </Box> */}
            <Box w={{base: '20%', md: '20%'}} display={{base: 'block', lg: 'none'}}>
                <MobileNav data={data} />
            </Box>            
        </Flex>
    )
}